<script>
    export let password = '';
    let confirmPassword = '';
    export let isValid = false;

    $: isLengthCorrect = password.length >= 6;
    $: doPasswordsMatch = password.length > 0 && password == confirmPassword;
    $: isValid = isLengthCorrect && doPasswordsMatch;
</script>

<div class="layout__row layout__row--collapsable">
    <div class="layout__column">
        <div class="layout__item">
            <input class="form__input {!isLengthCorrect ? 'form__input--invalid' : ''}" type="password" placeholder="Password" bind:value={password} />
        </div>
        <div class="layout__item">
            <input class="form__input {!doPasswordsMatch ? 'form__input--invalid' : ''}" type="password" placeholder="Confirm password" bind:value={confirmPassword} />
        </div>
    </div>
    <div class="layout__column">
        <div class="layout__item password-update">
            <div class="password-update__title">
                Password policy:
            </div>
            <div class="password-update__rule">
                <div class="password-update__indicator password-update__indicator--{isLengthCorrect}"></div>
                At least 6 characters in length
            </div>
            <div class="password-update__rule">
                <div class="password-update__indicator password-update__indicator--{doPasswordsMatch}"></div>
                Passwords match
            </div>
        </div>
    </div>
</div>

<style>
    .password-update__title {
        margin-bottom: 7.5px;
    }

    .password-update__rule {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
    }

    .password-update__indicator {
        height: 10px;
        width: 10px;
        border: 1px #333 solid;
        border-radius: 50%;
        margin: 0 5px 0 0;
        transition: background-color 0.1s linear;
    }

    .password-update__indicator--false {
        background-color: #eee;
    }

    .password-update__indicator--true {
        background-color: #74BE44;
    }
</style>